import client from "shared/setupClient";
import { loader } from "graphql.macro";
const addChecklistMutation = loader("graphql/mutations/checklist/addChecklist.graphql");
const fetchChecklistsQuery = loader("graphql/queries/checklist/fetchChecklists.graphql");

export default function addChecklistAction(organisationId) {
    return async (dispatch, getState) => {
        const { manageChecklists } = getState();
        const {checklist} = manageChecklists;
        const {label, description, items} = checklist;
        const mappedItems = items.map(({label, type, position}, index) => {
            const nextPosition = typeof position === "number" ? position : index + 1;
            return {label, type, position: nextPosition};
        });

        const filteredItems = mappedItems.filter(({label}) =>
            typeof label === "string" && label.length > 1 && label !== "");

        return client.mutate({
            mutation: addChecklistMutation,
            variables: {organisationId, label, description, items: filteredItems},
            refetchQueries:
                [{query: fetchChecklistsQuery, variables: {organisationId}}]
        });
    };
}
